import {
  AgendaItem,
  AgendaItemDoc,
  SpeakerDoc,
  TrackDoc,
} from '@livekatsomo/models';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'next-i18next';
import { AgendaForm } from './AgendaForm';

/**
 * Props for the AgendaDialog component.
 */
export interface AgendaDialogProps {
  open: boolean;
  agendaItem?: AgendaItemDoc | null;
  agendaItems: AgendaItemDoc[];
  speakers?: SpeakerDoc[] | null;
  track: TrackDoc;
  eventStartDate: Date;
  onClose: () => void;
  onSubmit: (values: AgendaItem) => Promise<void>;
}

/**
 * The AgendaDialog component is used to add or edit an agenda item.
 * @param {AgendaDialogProps} props - The props for the component.
 * @returns The JSX element for the component.
 */
export function AgendaDialog({
  open: isOpen,
  agendaItem,
  onClose,
  ...props
}: AgendaDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog scroll="body" open={isOpen} onClose={onClose} fullWidth>
      <Box sx={{ position: 'relative' }}>
        <DialogTitle>
          {agendaItem ? t('Edit Agenda Item') : t('Add Agenda Item')}
        </DialogTitle>
        <AgendaForm onClose={onClose} agendaItem={agendaItem} {...props} />
      </Box>
    </Dialog>
  );
}

export default AgendaDialog;
